module.exports = __webpack_public_path__ + "static/savoriurbane-23c91ece5ba6a37985b66e6b02b8731b.png";